import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Input,
  Modal,
  Checkbox,
} from "antd";

import api from "../../../services/finYearService";
import { recordError } from "../../../utils/logService";

import {
  Messages,
  Notify,
  openNotification,
  util
} from '@seims/shared';

const EditFinYear = ({ show, onShow, data, setHasUpdated }) => {
  const [selectedFinYear, setSelectedFinYear] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const currentFinYearLabel = `${selectedFinYear ? "Yes!" : "No!"}`;

  let msg = "";

  const [form] = Form.useForm();
  const entity = "Financial Year";
  const formName = "EditFinancialYear";

  useEffect(() => {
    getFinYearDetails();
  }, [data]);

  const getFinYearDetails = () => {
    const activeFlag = data.active == "Yes" ? true : false;

    form.setFieldsValue({
      value: data.finYear,
      startDate: data.startDate,
      endDate: data.endDate,
      active: activeFlag,
    });

    setSelectedFinYear(activeFlag);
  };


  const onSubmit = async (values) => {
    try {
      const selectedFinYear = { ...data, active: values.active };

      const response = await api.editFinYear(selectedFinYear);

      if (response && (response.status == 201 || response.status == 200)) {
        onShow(false);

        msg = util.parseMessage(Messages.ADD_SUCCESS, entity);
        openNotification(entity, msg, Notify.SUCCESS);
        setHasUpdated(true);

      } else {
        msg = util.parseMessage(Messages.ADD_FAILURE, entity);
        openNotification(entity, msg, Notify.ERROR);
      }
    } catch (error) {
      if (error && error.response.status == 409) {
        msg = util.parseMessage(Messages.CONFLICT, entity);
        openNotification(entity, msg, Notify.ERROR);
        return;
      }

      msg = util.parseMessage(Messages.ADD_FAILURE, entity);
      openNotification(entity, msg, Notify.ERROR);
      recordError(error);
    }
  };

  const onChangeCheck = (e) => {
    const { checked } = e.target;
    form.setFieldsValue({ active: checked });
    setSelectedFinYear(checked);
  };

  const handleCancel = () => {
    form.resetFields();
    onShow(false);
    setDisabled(true);
  };

  return (
    <>
      <Modal
        forceRender
        title="Activate/De-Activate Financial Year"
        open={show}
        closable={false}
        keyboard={false}
        maskClosable={false}
        width={500}
        footer={[
          <div className="modal-footer-buttons">
            <Button
              key="2"
              type="primary"
              htmlType="submit"
              onSubmit={onSubmit}
              form={formName}
            >
              Save
            </Button>
            <Button onClick={handleCancel} style={{ marginLeft: 10 }}>
              Cancel
            </Button>
          </div>,
        ]}
      >
        <Form
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 18,
          }}
          form={form}
          name={formName}
          onFinish={onSubmit}
        >
          <Form.Item name="value" label="Financial Year">
            <Input
              name="value"
              disabled={true}
            />
          </Form.Item>

          <Form.Item name="startDate" label="Start Date">
            <Input name="startDate" disabled={true} />
          </Form.Item>
          <Form.Item name="endDate" label="End Date">
            <Input name="endDate" disabled={true} />
          </Form.Item>
          <Form.Item
            name="active"
            label="Activate Fin Year?"
            rules={[{ required: false }]}
          >
            <Checkbox
              name="active"
              onChange={onChangeCheck}
              checked={selectedFinYear}
            >
              {currentFinYearLabel}
            </Checkbox>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default EditFinYear;
